<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-light bg-light sticky-top">
      <div class="container-fluid">
        <a>
          <div style="padding-top:4px;padding-right:10px;"><img @click="go(0)" style="height:70px ;width:170px;" src="./images/logo.svg" alt="" /></div>
        </a>
        <b-navbar-toggle class="navbar-toggler" type="button" data-toggle="collapse" target="navbar-toggle-collapse">
          <template>
            <span class="navbar-toggler-icon"></span>
          </template>
        </b-navbar-toggle>
        <b-collapse id="navbar-toggle-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item :class="tage == 0 ? 'clickcolor' : ''" @click="go(0)">首页</b-nav-item>
            <!-- <b-nav-item :class="tage == 1 ? 'clickcolor' : ''" @click="go(1)">雅思</b-nav-item> -->
            <b-nav-item :class="tage == 2 ? 'clickcolor' : ''" @click="go(2)">留学</b-nav-item>
<!--            <b-nav-item :class="tage == 3 ? 'clickcolor' : ''" @click="go(3)">四六级</b-nav-item>-->
            <!-- <b-nav-item href="#backdrop" :class="tage == 4 ? 'clickcolor' : ''" @click="go(4)">背景提升</b-nav-item> -->
            <b-nav-item href="#about" :class="tage == 5 ? 'clickcolor' : ''" @click="go(5)">关于我们</b-nav-item>
            <b-nav-item class="login" v-if="!isLogin" v-b-modal.bv-modal-example1 @click="creatQrCode">
              <b-avatar class="my-avatar" size="2.5rem" square  src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/avar.png"></b-avatar>
              登录
            </b-nav-item>
            <b-nav-item v-else class="login" @mouseover="personalover" @mouseout="personalout">
              <b-avatar class="my-avatar" size="2.5rem" variant="info" :src="userAvater"></b-avatar>
              {{ $store.state.name }}
            </b-nav-item>
            <div v-if="isLogin"   class="information-popup" :style="{ height: informationHight + 'rem' }" @mouseover="personalover" @mouseout="personalout">
              <div class="popup-name">{{ $store.state.name }}</div>
              <ul class="popup-list">
                <li @click="goCenter(0)">
                  <span></span>
                  课程日历
                </li>
                <li @click="goCenter(1)">
                  <span></span>
                  留学申请
                </li>
                <li @click="goCenter(2)">
                  <span></span>
                  直播课表
                </li>
                <li @click="goCenter(3)">
                  <span></span>
                  个人信息
                </li>
                <li @click="outLogin">
                  <span></span>
                  退出登录
                </li>
              </ul>
            </div>
          </b-navbar-nav>
        </b-collapse>
      </div>
      <b-modal id="bv-modal-example1" hide-footer hide-header>
        <!-- 登录二维码模块-->
        <div class="login-content">
<!--          <div class="login-code">-->
<!--            <p>嗡嗡雅思App扫码登录</p>-->
<!--            <div class="qr-code">-->
<!--              <div class="qrcode" ref="qrCodeUrl"></div>-->
<!--              <div v-if="QRCodeStudes == 2" class="qrcode-success"></div>-->
<!--              <div v-if="QRCodeStudes == 4" @click="creatQrCode" class="qrcode-overdue"></div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="login-phone">
            <p>账号密码登录</p>
            <b-form-input size="sm" id="myphone" type="tel" maxlength="11" v-model="phone" placeholder="输入手机号"></b-form-input>
            <div class="mycode">
              <b-form-input id="mycode" v-model="code" type="number" size="sm" placeholder="输入验证码"></b-form-input>
              <div class="code-bottom" @click="getCode" v-if="timeT == 60" size="sm">获取验证码</div>
              <div class="code-bottom" v-if="timeT != 60" size="sm">{{ timeT }}S</div>
            </div>
            <div class="logining" variant="primary" size="sm" @click="goLogin">登 录</div>
            <div class="login-remark">未注册嗡嗡雅思的手机号将自动注册并登录</div>
          </div>
        </div>
      </b-modal>
    </nav>
    <router-view />

    <footer>
      <b-container fluid>
        <b-row class="footer-top" align-h="center" align-v="center">
          <b-col style="padding-right:1.875rem;" cols="10" md="4" lg="4" xl="4"><img src="./images/footertop-left.png" alt="" /></b-col>
          <b-col align-v="center" cols="6" md="4" lg="2" xl="2"><img src="./images/footertop-right.png" alt="" /></b-col>
        </b-row>
      </b-container>
      <b-container fluid>
        <b-row class="" ref="backgroundHight">
          <div class="col-md-4 col-sm-6">
            <hr class="light" />
            <h6><a href="https://mp.weixin.qq.com/s/q2IPvR3jEwulE94FPSQpTQ">关于我们</a> </h6>
            <hr class="light" />
            <p class="about"><a href="http://app.honeybee-edu.com/html/download.html">嗡嗡雅思</a></p>
            <p class="about"><a href="https://beian.miit.gov.cn">蜀ICP备20016160号</a></p>
          </div>

          <div class="col-md-4 col-sm-6">
            <hr class="light" />
            <h6>蜂为科技</h6>
            <hr class="light" />
            <p>蜂为科技 Copyright ©2020 All rights reserved.</p>
          </div>
          <div class="col-md-4 col-sm-6">
            <hr class="light" />
            <h6>联系我们</h6>
            <hr class="light" />
<!--            <p class="information">-->
<!--              <img src="./images/footer-phone.png" alt="" />-->
<!--              185-8360-8007-->
<!--            </p>-->
            <p class="information">
              <img src="./images/footer-email.png" alt="" />
              customer@honeybee-edu.cn
            </p>
<!--            <p class="information">-->
<!--              <img src="./images/footer-adress.png" alt="" />-->
<!--              &nbsp;四川省成都市锦江区红星路三段1号-->
<!--            </p>-->
          </div>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { get_qrcode, random_code, send_sms, logins, student_profile, code_status } from '@/api/login.js'
import storage from 'good-storage'
export default {
  name: 'App',
  data () {
    return {
      tage: 0,
      backgroundHight: 0, // 背景提升距离顶部距离
      aboutHeight: 0, // 关于我们距离顶部距离
      isLogin: false, // 是否登录
      informationHight: 0, // 弹出框高度,height:13.1875rem
      timeT: 60, // 倒计时
      phone: '', // 手机号
      code: '', // 验证码
      studentName: '', // 名字
      avatar: '', // 头像
      QRCodes: '', // 二维码生成code
      QRCodeStudes: 1, // 扫码状态
      timeTs: '',
      times: ''
    }
  },
  watch: {
    $route: function (to, from) {
      console.log(to)
      console.log(from)
      if (to.name == null) {
        this.$router.push('/')
        this.tage = 0
      }
      if (to.name == 'ielts') {
        this.tage = 1
      } else if (to.name == 'studyabroad') {
        this.tage = 2
      } else if (to.name == 'cet') {
        this.tage = 3
      }
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }

  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  created () {
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('messageStore', JSON.stringify(this.$store.state))
    })
    // 在页面加载时读取localStorage里的状态信息
    sessionStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(sessionStorage.getItem('messageStore'))))
    this.distance()
    const token = localStorage.getItem('token')
    if (token && token.length > 0) {
      this.isLogin = true
      this.studentProfile()
    }
  },
  methods: {
    codeStatus () {
      // 二维码状态
      // let that = this
      // var timeStutes = 60
      // clearInterval(this.timer)
      // this.timer = setInterval(() => {
      //   timeStutes--
      //   code_status(that.QRCodes)
      //     .then(response => {
      //       that.QRCodeStudes = response.data.status
      //       if (that.QRCodeStudes == 3) {
      //         // 已经扫码
      //         localStorage.setItem('token',response.data.token)
      //         that.isLogin = true
      //         that.studentProfile()
      //         that.$bvModal.hide('bv-modal-example1')
      //         clearInterval(that.timer)
      //       }
      //       if (timeStutes <= 0) {
      //         // 过期生效
      //         that.QRCodeStudes = 4
      //         clearInterval(that.timer)
      //       }
      //     })
      //     .catch(error => {
      //       console.log(error)
      //     })
      // }, 1000)
    },

    outLogin () {
      // 退出登录
      localStorage.removeItem('token')
      this.isLogin = false
      this.informationHight = 0
      this.go(0)
    },
    studentProfile () {
      // 获取个人资料
      student_profile()
        .then(response => {
          console.log(response)
          if (response === 100020 || response === 100026 || response === 100027 || response === 100025 || response ===
           100022 || response === 100021) {
            this.$bvModal.show('bv-modal-example1')
            // this.creatQrCode()
            return false
          }
          this.$store.commit('name', response.data.name)
          this.$store.commit('avatar', response.data.avatar)
          this.$store.commit('ids', response.data.id)
          this.$store.commit('liveId', response.data.live_id)
          this.studentName = response.data.name
          this.studentAvatar = response.data.avatar
        })
        .catch(error => {
          console.log(error)
        })
    },
    goCenter (_type) {
      // 跳转个人中心
      this.$router.push({
        path: '/mycenter/mycenter',
        query: { type: _type }
      })
    },
    personalout () {
      // 关闭个人资料弹窗
      this.informationHight = 0
    },
    personalover () {
      // 显示个人资料弹窗
      this.informationHight = 16.1875
    },

    goLogin () {
      // 登录
      logins({
        phone: this.phone,
        code: this.code
      })
        .then(response => {
          localStorage.setItem('token',response.data.token)
          clearInterval(this.timer)
          this.isLogin = true
          this.studentProfile()
          this.$bvModal.hide('bv-modal-example1')
          this.goCenter(0)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCode () {
      // 获取手机验证码
      let that = this
      if (!RegExp(/^1[3465789]\d{9}$/).test(this.phone)) {
        this.$bvToast.toast('请输入正确的手机号!', {
          title: '提示',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          solid: true
        })
        return false
      }
      if (that.timeT != 60) {
        return
      }
      that.timeT = 59
      clearInterval(this.timeTs)
      send_sms({
        phone: this.phone
      })
        .then(response => {
          that.timeTs = setInterval(() => {
            that.timeT--

            if (that.timeT <= 0) {
              that.timeT = 60
              clearInterval(that.timeTs)
            }
          }, 1000)
        })
        .catch(error => {
          console.log(error)
        })
    },
    creatQrCode () {
      // 创建二维码
      let that = this
      get_qrcode()
        .then(response => {
          // setTimeout(function () {
          //   that.$refs.qrCodeUrl.innerHTML = ''
          //   that.QRCodeStudes = 1
          //   that.QRCodes = response.data
          //   var qrcode = new QRCode(that.$refs.qrCodeUrl, {
          //     text: response.data, // 需要转换为二维码的内容
          //     width: 183,
          //     height: 183,
          //     colorDark: '#000000',
          //     colorLight: '#ffffff',
          //     correctLevel: QRCode.CorrectLevel.H
          //   })
          // }, 100)

          that.codeStatus()
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleScroll () {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    },
    distance () {
      // 距离顶部的距离
      this.backgroundHight = this.$refs.backgroundHight
    },
    go (_index) {
      this.tage = _index
      if (_index == 0) {
        this.$router.push('/')
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      } else if (_index == 1) {
        this.$router.push('/ielts/ielts')
      } else if (_index == 2) {
        this.$router.push('/studyabroad/studyabroad')
      } else if (_index == 3) {
        this.$router.push('/cet/cet')
      } else if (_index == 4) {
        this.$router.push('/')
      } else if (_index == 5) {
        this.$router.push('/')
      }
    },
    gocet () {
      this.$router.push('/cet/cet')
    },
    gostudyabrod () {
      this.$router.push('/studyabroad/studyabroad')
    },
    gocoursedetails () {
      this.$router.push('/coursedetails/coursedetails')
    }
  },
  computed: {
    userAvater: {
      get() {
        if (this.isLogin && this.$store.state.avatar) {
          return this.$store.state.avatar
        } else {
          return "https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/avar.png"
        }
      }
    }
  }
}
</script>

<style>
  .modal{
    background-color: transparent;
  }
  .modalShow-header{

    display: none;
  }

html,
body {
  height: 100%;
}
body {
  overflow-y: scroll;
}
.col-sm-6>h6>a{
  color: #FFFFFF!important;
}

input {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input::-ms-clear {
  display: none;
}
.popup-list {
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 0.8125rem;
  font-weight: 400;
  text-align: left;
  list-style: none;
  color: #1a1a1a;
  padding: 0;
  margin: 0.4375rem 0 0 0;
}
.popup-list li span {
  width: 0.8125rem;
  height: 1rem;
  display: inline-block;
  background-image: url(images/personal-icon-b.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: -0.2rem;
  margin-right: 0.525rem;
}
.popup-list li span:nth-child(1) {
  width: 0.8125rem;
  height: 1rem;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: -0.2rem;
  margin-right: 0.525rem;
}
.popup-list li:nth-child(1) span {
  background-image: url(./images/personal-icon-b.png);
}
.popup-list li:nth-child(2) span {
  background-image: url(./images/order-icon-b.png);
}
.popup-list li:nth-child(3) span {
  width: 1rem;
  height: 1rem;
  background-image: url(./images/overseas-study-icon-b.png);
}
.popup-list li:nth-child(5) span {
  width: 0.8125rem;
  height: 0.8125rem;
  background-image: url(./images/signout-icon-b.png);
}
.popup-list li:nth-child(4) span {
  width: 1rem;
  height: 1rem;
  background-image: url(./images/live-b.png);
}
.popup-list li:nth-child(1):hover span {
  background-image: url(./images/personal-icon-w.png);
}
.popup-list li:nth-child(2):hover span {
  background-image: url(./images/order-icon-w.png);
}
.popup-list li:nth-child(3):hover span {
  background-image: url(./images/overseas-study-icon-w.png);
}
.popup-list li:nth-child(5):hover span {
  background-image: url(./images/signout-icon-w.png);
}
.popup-list li:nth-child(4):hover span {
  background-image: url(./images/live-w.png);
}
.popup-list li {
  cursor: pointer;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  padding: 0 1.25rem;
}
.popup-list li:hover {
  color: #ffffff;
  background: linear-gradient(89deg, #fdcf00 0%, #fdb100 100%);
}
.popup-name {
  background: linear-gradient(180deg, #fdd000 0%, #fdb100 100%);
  width: 100%;
  height: 2.75rem;
  padding: 0 1.25rem;
  line-height: 2.75rem;
  font-size: 0.8125rem;
  font-weight: bold;
  color: #1a1a1a;
  text-align: left;
}
.information-popup {
  width: 10.6875rem;
  /*  height: 13.1875rem; */
  background-color: #ffffff;
  position: absolute;
  right: 2.5rem;
  top: 4.8rem;
  background: #ffffff;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);
  border-radius: 0.3125rem;
  overflow: hidden;
  transition: all 0.5s;
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 1);
  margin-right: 1.25rem;
}
.ml-auto {
  display: flex;
  align-items: center;
}
.my-avatar {
  margin-right: 0.35rem;
  background-color: #f8f9fa;
}
.logining {
  width: 16rem;
  height: 2.3125rem;
  background: #fd9800;
  opacity: 1;
  border-radius: 23px;
  text-align: center;
  font-size: 13px;
  line-height: 2.3125rem;
  color: #1a1a1a;
  margin: 3.125rem auto 1.75rem auto;
  cursor: pointer;
}
.mycode {
  display: flex;
  justify-content: space-between;
  padding: 0 7.5%;
  position: relative;
  margin-top: 1.875rem;
}
#mycode {
  width: 100%;
  border-bottom: 1px solid #aaaaaa;
  border-radius: 0;
}
.mycode div {
  position: absolute;
  font-size: 0.775rem;
  padding: 0 0.3125rem;
  margin-left: 5%;
  border: none;
  right: 20px;
  bottom: 5px;
  color: #fd9800;
  cursor: pointer;
}
.code-bottom {
  background-color: #ffffff;
  color: #999999;
   -moz-user-select:none; /* Firefox私有属性 */
      -webkit-user-select:none; /* WebKit内核私有属性 */
      -ms-user-select:none; /* IE私有属性(IE10及以后) */
      -khtml-user-select:none; /* KHTML内核私有属性 */
      -o-user-select:none; /* Opera私有属性 */
      user-select:none; /* CSS3属性 */
}
#myphone {
  background: none;
  outline: none;
  border: none;
  border-bottom: 1px solid #aaaaaa;
  border-radius: 0;
}
#myphone:focus {
  border: none;
  border-bottom: 1px solid #aaaaaa;
}
input::-webkit-input-placeholder {
  // 谷歌
  color: red !important;
  font-size: 12px;
}
.form-control:focus {
  border-color: #fff;
  webkit-box-shadow: none;
  box-shadow: none;
}
.form-control {
  border: 0;
  webkit-box-shadow: none;
  box-shadow: none;
}
.login-remark {
  font-size: 0.625rem;
  font-weight: 400;
  color: #aaaaaa;
  text-align: center;
}
#bv-modal-example1 .modal-content {
  background-image: url(images/loginbg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /*width: 42.1875rem;*/
  height: 27.1875rem;
  border: none !important;
  border-radius: 0.625rem;
  margin: 10rem auto;
}
.login-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
#myphone {
  width: 85% !important;
  display: block;
  margin: 3.825rem auto 1.25rem auto !important;
}
.qr-code {
  margin: 3.125rem auto;
  text-align: center;
  position: relative;
}
.qrcode-overdue {
  position: absolute;
  width: 183px;
  height: 183px;
  background-image: url(images/QCoverdue.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.qrcode-success {
  position: absolute;
  width: 183px;
  height: 183px;
  background-image: url(images/QCsuccess.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.qrcode {
  margin: 3.125rem auto;
}
.qrcode img {
  display: block;
  margin: 0 auto;
}
.login-code,
.login-phone {
  /*width: 18.75rem;*/
  width: 100%;
  margin-top: 3.125rem;
}

.login-code p,
.login-phone p {
  text-align: center;
  font-size: 1.125rem;
  font-weight: bold;
}
.is-nav-list .dropdown-item {
  font-size: 0.9rem;
  text-align: center;
}
.b-popover li {
  list-style: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
.about a {
  color: #ffffff;
}
.nav-item a {
  font-size: 1.125rem;
}
.clickcolor a {
  color: #f2c52d !important;
}
.nav-item a:hover {
  color: #f2c52d !important;
}

footer {
  width: 100%;
  z-index: 9999;
  background-image: url(images/footer-bg.png);
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 0.8125rem;
}

.footer-top {
  background-image: url(images/footer-topbg.png);
  background-size: 100% 100%;
  border-bottom: 2px solid #ffffff;
}
.footer-top img {
  width: 100%;
  padding: 1.5rem 0;
}
.information img {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.625rem;
}
p {
  margin: 0 !important;
}
  .login{
    display: none;
  }
@media (min-width: 576px) {
  .footer-top img {
    padding: 1.5rem 0;
  }
  .login{
    display: none;
  }
  #bv-modal-example1.modal-dialog {
    width: 42.1875rem !important;
    height: 27.1875rem !important;
    margin: 1.75rem auto;
  }
}

@media (min-width: 768px) {
  .footer-top img {
    padding: 1.5rem 0;
  }
  .login{
    display: none;
  }
}

@media (min-width: 992px) {
  .footer-top img {
    padding: 2.5rem 0;
  }
  .login{
    display: block;
  }
}

@media (min-width: 1200px) {
  .footer-top img {
    padding: 2.5rem 0;
  }
  .login{
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue